// extracted by mini-css-extract-plugin
module.exports = {"submit-error":"SubmitError_submit-error__T8Mb7"};